module.exports = __webpack_public_path__ + "img/icon_1_24.e18f55ba.png";